import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Constants } from '../constants';
import { PageTitleService } from '../services/page-title.service';

@Component({
    selector: 'app-header-page',
    templateUrl: './header-page.component.html',
    standalone: false
})
export class HeaderPageComponent implements OnInit, OnDestroy {

  isScreenSmall: Observable<boolean>;

  constructor(
    public titleSrvice: PageTitleService,
    private breakpoints: BreakpointObserver,
  ) {
    this.isScreenSmall = this.breakpoints.observe(`(max-width: ${Constants.SMALL_WIDTH_BREAKPOINT}px)`)
      .pipe(map(breakpoint => breakpoint.matches));
  }

  ngOnInit(): void {
    // can perform any logical implemention here if required
  }

  ngOnDestroy(): void {
    // can perform any logical implemention here if required
  }
}

export class ActionHeaderMenu {
  /** The text to be displayed on the menu. */
  DisplayText: string;
  /** Name of the icon to be used. */
  Icon: string;
  /** Function to be triggered on click */
  Onclick: () => void;

  constructor(options: { DisplayText: string, Icon: string, Onclick: () => void }) {
    this.DisplayText = options.DisplayText || '';
    this.Icon = options.Icon || '';
    this.Onclick = options.Onclick || (() => { alert(1); });
  }
}
